@if (adventureQuest) {
  <div
    class="c-adventureQuest"
    theming
    themingGroup="adventurequest"
    themingAsset="background"
    [themingOverride]="adventureQuest?.assets">
    <slotcom-wallet
      [type]="'Coins'"
      [animate]="true"></slotcom-wallet>

    <slotcom-navigation-button
      type="close"
      (click)="closeModal()">
    </slotcom-navigation-button>

    <slotcom-navigation-button
      type="info"
      (click)="openInfo()">
    </slotcom-navigation-button>

    <div
      class="c-left-container"
      theming
      themingGroup="adventurequest"
      themingAsset="map"
      [themingOverride]="adventureQuest?.assets">
      <span
        class="c-adventureQuest__icon"
        theming
        themingGroup="adventurequest"
        themingAsset="logo"
        [themingOverride]="adventureQuest?.assets"></span>
      <slotcom-adventure-quest-challenge-box
        [event]="adventureQuest"
        [eventChallengeStatus]="currentChallengeStatus"></slotcom-adventure-quest-challenge-box>
      <div class="c-adventureQuest__events_timer">
        <span class="text">{{ 'home.live-ops.global.time-left' | translate }}</span>
        <slotcom-animated-timer
          [showInDays]="true"
          [endDate]="adventureQuest.endDate"
          (expired)="onExpiredChallenge()"></slotcom-animated-timer>
      </div>
    </div>
    <div class="c-container">
      <div class="c-adventureQuest__title">
        <span class="text title">{{ 'home.live-ops.adventure-quest.title' | translate | uppercase }}</span>
        <span class="text subtitle">{{ 'home.live-ops.adventure-quest.subtitle' | translate }}</span>
      </div>
      <div
        invertMouseScroll
        id="adventureQuest-scroll-container"
        class="c-adventureQuest__container">
        <div class="c-adventureQuest__events">
          <div class="c-adventureQuest__events_cards">
            @for (event of adventureQuest.properties.challengestatuses; track event; let i = $index) {
              <slotcom-adventure-quest-reward-box
                [id]="'adventureQuest-scroll-container-' + i"
                [event]="adventureQuest"
                [eventChallengeProgressive]="challengeProgressive[getChallengeProgressiveRewardPosition(i)]"
                [rewardAssetSize]="rewardAssetSize[getChallengeProgressiveRewardPosition(i)]"
                [isLoading]="isLoadingByIndex()[i]"
                (collectReward)="collectReward($event)">
              </slotcom-adventure-quest-reward-box>
            }
          </div>
          <slotcom-progress-bar
            [classes]="['c-progress-bar--green-white']"
            [currentProgress]="adventureQuest.current"
            [totalProgress]="adventureQuest.total"
            [completed]="adventureQuest.current === adventureQuest.total">
            <div class="progress-icons">
              @for (event of adventureQuest.properties.challengestatuses; track event; let i = $index) {
                <span
                  class="icon"
                  theming
                  themingGroup="adventurequest"
                  themingAsset="step"
                  [themingOverride]="adventureQuest?.assets">
                  <span class="text icon-number">
                    {{ i + 1 }}
                  </span>
                </span>
              }
            </div>
          </slotcom-progress-bar>
        </div>
        @if (showArrows()) {
          <span
            moveWithArrows
            direction="left"
            [scrollDistance]="280"
            scrollContainer="adventureQuest-scroll-container"
            class="arrows left-arrow"></span>
          <span
            moveWithArrows
            direction="right"
            [scrollDistance]="280"
            scrollContainer="adventureQuest-scroll-container"
            class="arrows right-arrow"></span>
        }
      </div>
    </div>
  </div>
}
